import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const servicesAnim = [
  {
    id: 1,
    title: "WhatsApp Services",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    content: ["WhatsApp Marketing", "Click To WhatsApp Ads", "WhatsApp Chatbots", "WhatsApp Business API", "WhatsApp Blue Tick"],
    image: require("../../assets/images/os-1.webp"),
  },
  {
    id: 2,
    title: "SMS Services",
    colorClass: "red-service",
    dotClass: "red-dot",
    content: ["Bulk SMS", "RCS SMS"],
    image: require("../../assets/images/os-2.webp"),
  },
  {
    id: 3,
    title: "Social Media Marketing",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    content: ["Facebook & Instagram", "LinkedIn"],
    image: require("../../assets/images/os-3.webp"),
  },
  {
    id: 4,
    title: "Digital Marketing",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    content: ["SEO", "PPC Campaign", "Google Ads"],
    image: require("../../assets/images/os-5.webp"),
  },
];
const contentRoutes = {
  "WhatsApp Marketing": "/",
  "Click To WhatsApp Ads": "/click_to_whatsappads",
  "WhatsApp Chatbots": "/whatsapp_chatbots",
  "WhatsApp Business API": "/whatsapp_business_api",
  "WhatsApp Blue Tick": "/whatsapp_bluetick",
  "Sender ID SMS": "/SenderIDSMS",
  "Bulk SMS":"/bulk_sms",
  "RCS SMS": "/rcs_messages",
  "Facebook & Instagram": "/facebook_instagram_marketing",
  LinkedIn: "/linkedin_ads",
  SEO: "/search_engine_optimization",
  "PPC Campaign": "/pay_per_click",
  "Google Ads": "/google_ads",
};

const ServiceSection2 = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);
  const [startScroll, setStartScroll] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [hasActivatedOnce, setHasActivatedOnce] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      let newActiveIndex = null;

      cardRefs.current.forEach((ref, index) => {
        if (ref) {
          const rect = ref?.getBoundingClientRect();
          if (rect.top <= 140 && rect.bottom > 140) {
            newActiveIndex = index;
          }
        }
      });
      console.log("Active Index:", newActiveIndex);
      setActiveIndex(newActiveIndex);

      // Activate full-height mode after first card hits 140
      if (newActiveIndex !== null && !hasActivatedOnce) {
        setHasActivatedOnce(true);
      }

      // 🆕 Reset if scrolled above the first card
      const firstCard = cardRefs.current[0];
      if (firstCard) {
        const firstRect = firstCard.getBoundingClientRect();
        if (firstRect.top > 140) {
          setActiveIndex(null);
          setHasActivatedOnce(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasActivatedOnce]);

  return (
    <div ref={sectionRef}>
      <div className="row justify-content-end min-h reshidden">
        {/* Left Side */}
        <div className="col-lg-6 col-md-6">
          <ul className="list-unstyled">
            {servicesAnim.map((service, index) => {
              const isActive = activeIndex === index;

              return (
                <li
                  key={service.id}
                  ref={(el) => (cardRefs.current[index] = el)}
                  className={`service-item-anim ${hasActivatedOnce ? "active" : ""
                    }`}
                >
                  <div
                    className={`service-card-wrapper ${isActive ? "sticky" : ""
                      }`}
                  >
                    <div className="d-flex-service-anim-card">
                      <div className="border-dot">
                        <div className={service.dotClass}></div>
                      </div>
                      <div>
                        <h2 className="service-heading"
                        // data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
                        >{service.title}</h2>
                      </div>
                    </div>

                    <AnimatePresence>
                      {isActive && (
                        <motion.div
                          className="service-content-section"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.2, ease: "easeOut" }}
                        >
                          <div className="tabs tabs1">
                            {service.content.map((text, idx) => {
                              const path = contentRoutes[text] || "#"; // fallback to "#" if route not defined

                              return (
                                <Link
                                  to={path}
                                  key={idx}
                                  className="tab mb-4 text-decoration-none text-dark"
                                >
                                  <span>
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span className="fs-4">{text}</span>
                                </Link>
                              );
                            })}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                    <div className="d-lg-none d-md-none d-block">
                      <AnimatePresence mode="wait">
                        {isActive && (
                          <motion.div
                            key={activeIndex}
                            className="position-relative"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.6 }}
                          >
                            <img
                              src={require("../../assets/images/circle.webp")}
                              className="div-ourservices-bg-circle"
                              alt="circle"
                            />
                            <img
                              className="services-anim-side-img"
                              src={servicesAnim[activeIndex].image}
                              alt="service"
                            // style={{width=}}
                            />
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Right Side Image */}
        <div className="col-lg-5 col-md-6 d-lg-block d-md-block d-none">
          <div
            className={`sticky-img-wrapper ${activeIndex === servicesAnim.length - 1 ? "centered-last" : ""
              }`}
          >
            <AnimatePresence mode="wait">
              {activeIndex !== null && (
                <motion.div
                  key={activeIndex}
                  className="position-relative"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <img
                    src={require("../../assets/images/circle.webp")}
                    className="div-ourservices-bg-circle"
                    alt="circle"
                  />
                  <img
                    className="services-anim-side-img"
                    src={servicesAnim[activeIndex].image}
                    alt={servicesAnim[activeIndex].title}
                  />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection2;
